export default __webpack_public_path__ + "/dist/images/linkedin.575a96bb9fe4faa8c3746f2619de9005.svg";